import { downloadXlsx } from "./spreadsheet";

/**
 * The raw data table as an XLSX, exactly as the grid shows it: its visible
 * columns in their order, under their headers, each value as the grid
 * formats it. `rows` are the grid's rows as shown (sorted, imaging times in
 * the user's timezone); `columns` its visible column definitions (see
 * headers.js rawDataColumns). (Every other table downloads through
 * ModalRouter/Reports/PivotTable.)
 */
export const downloadRawData = (rows, columns, title) => {
  if (!rows?.length) return;
  const shown = (row, column) => {
    const value = row[column.field];
    const formatted = column.valueFormatter ? column.valueFormatter(value, row, column) : value;
    return formatted ?? "";
  };
  downloadXlsx({
    title,
    sheetName: "Raw data",
    rows: [columns.map((c) => c.headerName ?? c.field), ...rows.map((row) => columns.map((c) => shown(row, c)))],
  });
};
